(() => {
  const mobileMediaQuery = window.matchMedia('(max-width: 749px)');

  const setHiddenState = (element, shouldHide) => {
    if (shouldHide) {
      element.setAttribute('hidden', 'hidden');
    } else {
      element.removeAttribute('hidden');
    }
  };

  const getButtonLabel = (button) => {
    const label = button.querySelector('span');
    return (label?.textContent || button.textContent || '').trim();
  };

  const syncButtonState = (stickyButton, sourceButton) => {
    const isDisabled =
      sourceButton.hasAttribute('disabled') || sourceButton.getAttribute('aria-disabled') === 'true';

    stickyButton.toggleAttribute('disabled', isDisabled);

    const stickyLabel = stickyButton.querySelector('span');
    if (stickyLabel) {
      stickyLabel.textContent = getButtonLabel(sourceButton);
    }
  };

  const initStickyAddToCart = (stickyBar) => {
    if (stickyBar.dataset.stickyCartReady === 'true') return;
    stickyBar.dataset.stickyCartReady = 'true';

    const stickyButton = stickyBar.querySelector('[data-sticky-add-to-cart-trigger]');
    const sourceButtonId = stickyBar.dataset.sourceButtonId;
    const sourceButton = sourceButtonId ? document.getElementById(sourceButtonId) : null;

    if (!stickyButton || !sourceButton) {
      setHiddenState(stickyBar, true);
      return;
    }

    let sourceVisible = true;

    const updateVisibility = () => {
      setHiddenState(stickyBar, !mobileMediaQuery.matches || sourceVisible);
    };

    const sync = () => {
      syncButtonState(stickyButton, sourceButton);
      updateVisibility();
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          sourceVisible = entries[0]?.isIntersecting ?? true;
          updateVisibility();
        },
        { threshold: 0.2 }
      );

      observer.observe(sourceButton);
    } else {
      sourceVisible = false;
    }

    const mutationObserver = new MutationObserver(sync);
    mutationObserver.observe(sourceButton, {
      attributes: true,
      attributeFilter: ['aria-disabled', 'class', 'disabled'],
      childList: true,
      subtree: true,
      characterData: true,
    });

    stickyButton.addEventListener('click', (event) => {
      event.preventDefault();
      if (stickyButton.hasAttribute('disabled')) return;
      sourceButton.click();
    });

    const handleViewportChange = () => updateVisibility();
    if (typeof mobileMediaQuery.addEventListener === 'function') {
      mobileMediaQuery.addEventListener('change', handleViewportChange);
    } else if (typeof mobileMediaQuery.addListener === 'function') {
      mobileMediaQuery.addListener(handleViewportChange);
    }

    sync();
  };

  const initAllStickyBars = (root = document) => {
    root.querySelectorAll('[data-sticky-add-to-cart]').forEach(initStickyAddToCart);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllStickyBars());
  } else {
    initAllStickyBars();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) {
      initAllStickyBars(event.target);
    }
  });
})();
